import { useQuery } from "react-query";

import { ItemsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosResponse } from "axios";
import { MasterInstance } from "instance/axios";

export type ItemOption = {
  value: string;
  label: string;
  group: string;
};
const getAutoCompleteKeyword = (
  keyword: string,
  itemType?: "PRODUCT" | "MATERIAL" | 'PRODUCT,SEMI_PRODUCT' | 'SUBSIDIARY' | 'SEMI_PRODUCT'
) =>
MasterInstance.itemsFindPost(
    {
      search: keyword,
      searchFields: ["name", "code"],
      populate: ["itemCategory"],
    },
    {
      params: {
        ...(!keyword && { limit: 50 }),
        query: {
          itemType: itemType?.split(",") ?? itemType,
        },
      },
    }
  ).then((res: AxiosResponse<ItemsGet200ResponseRowsInner[]>) => res.data);

export const useItemsAutoComplete = (
  focus = false,
  keyword = "",
  itemType?: "PRODUCT" | "MATERIAL" | 'PRODUCT,SEMI_PRODUCT' | 'SUBSIDIARY' | 'SEMI_PRODUCT',
  options?: {
    onSuccess: (data: ItemOption[]) => void;
  }
) => {
  
  return useQuery(
    ["items-get-autocomplete-keyword", keyword],
    () => getAutoCompleteKeyword(keyword, itemType),
    {
      enabled: focus,
      select: (data: ItemsGet200ResponseRowsInner[]) =>
        data?.map((item) => {
          return {
            value: item.code,
            label: item.name,
            spec: item.spec,
            group: item.itemType,
            // group: String(item.itemCategoryId),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    }
  );
};

const getItemByCode = (code: string | null) =>
MasterInstance.itemsFindPost(
    {
      ...(code && { search: code }),
      searchFields: ["code"],
    },
    {
      ...(!code && { limit: 50 }),
      params: {
        query: {},
      },
    }
  ).then((res: AxiosResponse<ItemsGet200ResponseRowsInner[]>) => res.data);

export const useItemsCode = (
  enabled: boolean,
  code: string | null,
  options?: {
    onSuccess: (data?: ItemOption[]) => void;
  }
) => {
  return useQuery(["items-get-code", code], () => getItemByCode(code), {
    enabled: enabled ?? false,
    select: (data: ItemsGet200ResponseRowsInner[]) =>
      data?.map((item) => {
        return {
          value: item.code,
          label: item.name,
          group: String(item.itemCategoryName),
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
